import { useContext } from 'react';
import { assign } from 'xstate';
import { useInterpret } from '@xstate/react';
import { DataAccessContext } from '@chargify/data-access';

import { GlobalStateContext } from '../contexts';
import {
  cancelSubscription,
  CancelSubscriptionEvent,
  SetErrorEvent,
  SetSubscriptionStatusEvent,
} from '../machines/cancelSubscription';

export const useCancelSubscriptionService = (
  catalogId: number,
  subscriptionId: number
) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { subscriptionsService } = useContext(GlobalStateContext);
  return useInterpret(cancelSubscription, {
    services: {
      cancelSubscription: (
        context,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        { type, ...payload }: CancelSubscriptionEvent
      ) => {
        return dataAccess.cancelSubscription({
          ...payload,
          subscriptionId,
        });
      },
    },
    actions: {
      updateSubscription: (context, payload: SetSubscriptionStatusEvent) => {
        const {
          data: { state, scheduledCancellationAt, ...subscriptionDetails },
        } = payload;

        subscriptionsService.send({
          type: 'UPDATE_SUBSCRIPTION',
          catalogId,
          scheduledCancellationAt,
          ...subscriptionDetails,
          status: scheduledCancellationAt ? 'cancellation_scheduled' : state,
        });
      },
      setError: assign((context, event: SetErrorEvent) => {
        return {
          ...context,
          error: event.data,
        };
      }),
    },
  });
};
